import type { ITicketAssetFinanceAsset } from './TicketAssetFinanceAsset.interface';
import { AssetFinanceAssetAge } from '../assetFinance/AssetFinanceAssetAge.enum';

export default class TicketAssetFinanceAsset implements ITicketAssetFinanceAsset {
  lender: string;
  equipmentMakeAndModel: string;
  equipmentValue: number;
  buildYear: number;
  equipmentCondition: AssetFinanceAssetAge;

  static build = (data: ITicketAssetFinanceAsset) => new TicketAssetFinanceAsset(data);
  static blank = () => new TicketAssetFinanceAsset();

  /**
   * Constructor
   * @param {ITicketAssetFinanceAsset} data
   */
  constructor(data?: ITicketAssetFinanceAsset) {
    this.lender = data?.lender || '';
    this.equipmentMakeAndModel = data?.equipmentMakeAndModel || '';
    this.equipmentValue = parseFloat(data?.equipmentValue || 0);
    this.buildYear = parseInt(data?.buildYear || 0, 10);
    this.equipmentCondition = AssetFinanceAssetAge.of(
      data?.equipmentCondition?.name || data?.equipmentCondition
    );
  }
}
